export default (email: string) => /^.+@.+\..+$/.test(email);
